export const MAX_NUMBER = 2147483647;
